import React from 'react';
import PropTypes from 'prop-types';

const FormResponsesAggregation = ({ responsesAggregation }) =>
  responsesAggregation.map((question) => (
    <div key={question.questionId}>
      <div style={{ fontSize: 15, fontWeight: 500, marginTop: 15 }}>{question.title}</div>
      {Object.keys(question.data)
        .sort((a, b) => question.data[a] - question.data[b])
        .map((response) => (
          <div key={response} style={{ fontSize: 15, fontWeight: 300 }}>
            {response}: <span style={{ fontWeight: 500 }}>{question.data[response] || 0}</span>
          </div>
        ))}
    </div>
  ));
FormResponsesAggregation.propTypes = {
  responsesAggregation: PropTypes.array,
};
export default FormResponsesAggregation;
